export * from './device-registration.client';
import { DeviceRegistrationClient } from './device-registration.client';
export * from './notification.client';
import { NotificationClient } from './notification.client';
export * from './notification-callback.client';
import { NotificationCallbackClient } from './notification-callback.client';
export * from './notification-group.client';
import { NotificationGroupClient } from './notification-group.client';
export * from './notification-history.client';
import { NotificationHistoryClient } from './notification-history.client';
export * from './portal-global-notification.client';
import { PortalGlobalNotificationClient } from './portal-global-notification.client';
export * from './portal-global-notification-internal.client';
import { PortalGlobalNotificationInternalClient } from './portal-global-notification-internal.client';
export * from './recipient-settings.client';
import { RecipientSettingsClient } from './recipient-settings.client';
export * from './send-notification.client';
import { SendNotificationClient } from './send-notification.client';
export * from './telegram.client';
import { TelegramClient } from './telegram.client';
export * from './user-notification-push-history.client';
import { UserNotificationPushHistoryClient } from './user-notification-push-history.client';
export * from './user-notification-settings.client';
import { UserNotificationSettingsClient } from './user-notification-settings.client';
export const APIS = [DeviceRegistrationClient, NotificationClient, NotificationCallbackClient, NotificationGroupClient, NotificationHistoryClient, PortalGlobalNotificationClient, PortalGlobalNotificationInternalClient, RecipientSettingsClient, SendNotificationClient, TelegramClient, UserNotificationPushHistoryClient, UserNotificationSettingsClient];
